<script>
	import DateTimePicker from "../../Common/DateTimePicker.svelte";
	import {ignore} from "../../Common/tools";
	import {onMount} from "svelte";
	import {External, M} from "../../external";

	export let item, circleDetails, onChange = ignore;
	let availability = '';
	let pages = [];
  let dripDisabled = External.Website.communityLimited;

	let notifyChanged = () => {
		onChange();
	};

	let fillDefaultValues = () => {
		item.availability = {
			dripPeriod: 1,
			dripUnit: 'DAY',
			completedId: '',
			time: new Date().getTime(),
			...(item.availability || {})
		}
	}

	let onContentAvailabilityChange = () => {
		item.availability = {
			...(item.availability || {}),
			type: availability ? availability : null
		}

		notifyChanged();
	}

	onMount(() => {
		pages = [
			...circleDetails.pages.filter(page => page.settings?.trackContentCompletion),
			...circleDetails.groups
		].sort((first, second) => {
			return (first.pageGroup ? first.pageGroup.uiOrder : first.uiOrder) - (second.pageGroup ? second.pageGroup.uiOrder : second.uiOrder);
		}).flatMap(item => {
			if (item.pageGroup) {
				return item.pages.filter(page => page.settings?.trackContentCompletion).map(page => {
					return {
						id: page.id,
						name: item.pageGroup.name + '/' + page.name
					}
				});
			} else {
				return {
					id: item.id,
					name: item.name
				}
			}
		});
		availability = item.availability?.type || '';
		fillDefaultValues();
	});
</script>
<div class="info">
	<h5>{M.CONTENT_AVAILABILITY}</h5>
</div>
<select class="page-select" bind:value={availability} on:change={onContentAvailabilityChange}>
	<option value="">{M.RIGHT_AWAY}</option>
	<option value="DRIP" disabled={dripDisabled}>{M.DRIP}</option>
	<option value="ON_COMPLETE">{M.AFTER_COMPLETION}</option>
	<option value="SCHEDULED" disabled={dripDisabled}>{M.SCHEDULED_CONTENT}</option>
</select>
{#if availability === 'DRIP'}
  <span class="explainer-text col20 f-left">{M.DRIP_DESC}</span>
	<div class="multiple-items-picker f-left col20">
		<span class="help-text-left col20 t-left f-left mt-25 mb-5">{M.CONTENT_AVAILABILITY_AFTER}</span>
		<div class="input-wrapper input-wrapper2 f-left mb-5">
			<input on:keyup={notifyChanged}
						 type="number" min="1" step="1"
						 class="transition-border" placeholder={M.ENTER_DELAY}
						 bind:value={item.availability.dripPeriod}/>
		</div>
		<div class="input-wrapper input-wrapper2 f-right mb-5">
			<select on:click={notifyChanged} class="page-select"
							bind:value={item.availability.dripUnit}>
				<option value="DAY">{M.DAYS}</option>
				<option value="HOUR">{M.HOURS}</option>
				<option value="MINUTE">{M.MINUTES}</option>
			</select>
		</div>
	</div>
{/if}

{#if availability === 'ON_COMPLETE'}
	<select class="page-select" bind:value={item.availability.completedId} on:change={notifyChanged}>
		{#if !item.availability?.completedId}
			<option disabled value="">{pages.length > 0 ? M.SELECT_PAGE_TITLE : M.NO_TRACKED_PAGES}</option>
		{/if}
		{#each pages as page}
			<option value="{page.id}">{page.name}</option>
		{/each}
	</select>
{/if}
{#if item.availability?.type === 'SCHEDULED'}
	<DateTimePicker onChange={notifyChanged}
									bind:value={item.availability.time}/>
{/if}
